<template>
  <div class="opt-record">
    <div class="table-wrapper">
      <div class="table-scroll">
        <el-table ref="tableRef" :data="dataList" border size="small" style="width: 100%" :height="'100%'"
          v-loading="loading" row-key="_id" :row-class-name="getRowClass" @row-click="handleRowClick">
          <el-table-column type="expand">
            <template slot-scope="scope">
              <div class="diff-wrapper">
                <el-table :data="scope.row.diff || []" border size="small" style="width: 100%">
                  <el-table-column prop="key" label="字段" width="120"></el-table-column>
                  <el-table-column prop="before" label="变更前" min-width="200">
                    <template slot-scope="diffScope">
                      {{ formatDiffValue(diffScope.row, "before") }}
                    </template>
                  </el-table-column>
                  <el-table-column prop="after" label="变更后" min-width="200">
                    <template slot-scope="diffScope">
                      {{ formatDiffValue(diffScope.row, "after") }}
                    </template>
                  </el-table-column>
                </el-table>
              </div>
            </template>
          </el-table-column>
          <el-table-column type="index" label="序号" width="60">
            <template slot-scope="scope">
              {{ (params.page - 1) * params.pageSize + scope.$index + 1 }}
            </template>
          </el-table-column>
          <el-table-column prop="user.nickname" label="操作人"></el-table-column>
          <el-table-column prop="operationText" label="操作"></el-table-column>
          <el-table-column prop="createdAt" label="时间">
            <template slot-scope="scope">
              {{ formatDateTime(scope.row.createdAt) }}
            </template>
          </el-table-column>
        </el-table>
      </div>
    </div>
    <div class="pager">
      <el-pagination background layout="total, prev, pager, next, jumper" :current-page="params.page"
        :page-size="params.pageSize" :total="total" @current-change="pageChange" />
    </div>
  </div>
</template>

<script>
import api from "@/api";

export default {
  name: "LayoutConfigOptRecord",
  props: {
    shipId: {
      type: [Number, String],
      default: null
    }
  },
  data() {
    return {
      loading: false,
      dataList: [],
      total: 0,
      params: {
        page: 1,
        pageSize: 20
      },
      expandRowKeys: []
    };
  },
  watch: {
    shipId: {
      immediate: true,
      handler() {
        this.params.page = 1;
        this.getList();
      }
    }
  },
  methods: {
    formatDateTime(val) {
      if (!val) return "-";
      const d = new Date(val);
      if (Number.isNaN(d.getTime())) return "-";
      const pad = (n) => String(n).padStart(2, "0");
      return (
        d.getFullYear() +
        "-" +
        pad(d.getMonth() + 1) +
        "-" +
        pad(d.getDate()) +
        " " +
        pad(d.getHours()) +
        ":" +
        pad(d.getMinutes()) +
        ":" +
        pad(d.getSeconds())
      );
    },
    formatDiffValue(row, field) {
      if (!row) return "-";
      const raw = row[field];
      if (raw === null || raw === undefined || raw === "") return "-";
      if (row.key === "updatedAt") {
        const cleaned = String(raw).replace(/^"+|"+$/g, "");
        return this.formatDateTime(cleaned);
      }
      return raw;
    },
    async getList() {
      if (!this.shipId) return;
      this.loading = true;
      const res = await api.getLayoutConfigOptRecord(this.shipId, this.params);
      const items = (res.data && res.data.items) ? res.data.items : [];
      this.dataList = items.map((r) => ({
        ...r,
        operationText: r.operation === "edit" ? "更新" : "新增"
      }));
      this.total = (res.data && res.data.count) ? res.data.count : 0;
      this.loading = false;
    },
    pageChange(val) {
      this.params.page = val;
      this.getList();
    },
    handleRowClick(row) {
      // expand 仅当 diff 有值时可用（ElementUI expand icon 无法直接隐藏，使用 row-class + CSS 隐藏）
      if (!row || !row.diff || !row.diff.length) return;
      if (!this.$refs.tableRef || !this.$refs.tableRef.toggleRowExpansion) return;
      this.$refs.tableRef.toggleRowExpansion(row);
    },
    getRowClass({ row }) {
      if (!row || !row.diff || !row.diff.length) {
        return "row-expand-disable";
      }
      return "";
    }
  }
};
</script>

<style scoped>
.opt-record {
  padding: 0;
  height: 100%;
  display: flex;
  flex-direction: column;
}

.table-wrapper {
  flex: 1;
  min-height: 0;
  border: 1px solid #ebeef5;
}

.table-scroll {
  height: 100%;
  overflow: auto;
}

.diff-wrapper {
  padding: 8px;
}

.pager {
  display: flex;
  justify-content: flex-end;
  margin-top: 12px;
}

:deep(.el-table .row-expand-disable .cell .el-table__expand-icon) {
  display: none;
}
</style>
